<template>
  <div>
    <div class="spcore-box p-3">
      <div class="pb-3">
        <h2 class="hvh-h6">{{ title }}</h2>
      </div>
      <div class="v-card__text px-0">
        <div class="hvh-analysis-visualization__chart">
          <LineChart style="background-color: #f5fbfb" :chartData="data" :options="chartOptions" height="300px" @chart-created="$emit('refresh-data', $event)" />
          <loader v-if="isFiltering" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LineChart from '../charts/LineChart.vue';
export default {
  noExport: true,
  components: { LineChart },
  props: ['title', 'data', 'isFiltering', 'valueField', 'nameField'],
  data() {
    return {
      chartOptions: {
        backgroundColor: '#f5fbfb',
        yAxis: {
          name: 'Percentage',
          nameGap: 60,
          nameTextStyle: {
            fontWeight: 'bold',
            fontSize: 13
          },
        },
      }
    };
  },
  mounted() {
    this.$emit('refresh-data');
  },
}
</script>
